import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import React, { useEffect, useState, version } from 'react';
import { useSelector } from 'react-redux';
import { Modal } from 'reactstrap';
import { edit_icon, preview1, preview2, sitelogo } from '../../../assets/images';
import {
    convertCurrency,
    formatDate,
    generatePDF,
    generatePDFPreview2, GeneratePDFRender, GeneratePDFRenderOne,
    NewGeneratePDFRender,
} from '../../../components/Common/CommonLogic';
import PreviewCommonTable from './PreviewCommonTable';
import PreviewFormat1 from './PreviewFormat1';
import PreviewFormat2 from './PreviewFormat2';
import { postTenantQuotationSummeryDetails } from '../../../store/Sales/actions';
import { useDispatch } from 'react-redux';
import {draft, locationTypeMap, MGR_APPRV_PENDING, VERIFIED} from '../../Dashboard/Partials/initialData';
import { PDFDownloadLink } from '@react-pdf/renderer';
import Select from "react-select";
import {optionModeQuote} from "../../../common/data/sales";
import {getVendorCarrierDataAction} from "../../../store/Parties/Vendor/action";

export default function PreviewQuotationModal({ previewModal, previewModalHand, setPreviewModal, QuoteModalHandler, isDraftDisplay = true, isSingleData, quotationData, isEditDisplay=true }) {
    const [previewFormat, setPreviewFormat] = useState('1');
    const [customerInfo, setCustomerInfo] = useState();
    const { vendor_carrier_data, vendor_loader } = useSelector((state) => state?.vendor);
    const quoteData = useSelector((state) => state.instantRate.quote_selected_data);
    const quoteSelectedTenantdata = useSelector((state) => state.instantRate.quote_selected_tenantdata);
    const { searchForm, $instantActiveTab, instantInquiryId } = useSelector((state) => state?.instantRate);
    const { customer_data } = useSelector((state) => state?.customer);
    const mainChargeObj = useSelector((state) => state?.quotation?.mainChargeObj);
    const dispatch = useDispatch();
    const [isManagerApproval, setIsManagerApproval] = useState(false);
    const { status_master, reason_master, oceanPort_data, vendor_data, UOM_data, currency_data, container_data } = useSelector(state => state?.globalReducer);
    const { login_user_data } = useSelector((state) => state.Login);
    const { currency_ExchangeRate } = useSelector((state) => state.quotation);
    const { tenant_info } = useSelector((state) => state?.settings);
    const [templateList, setTemplateList] = useState([
        { value: '1', label: 'Template 1' },
        { value: '2', label: 'Template 2' },
    ]);
    const [selectTemplate, setSelectTemplate] = useState({});

    useEffect(() => {
        dispatch(getVendorCarrierDataAction(''));
    }, [dispatch]);

    useEffect(() => {
        //console.log("quotationData", quotationData);
        
        console.log("quoteData", quoteData);
        let data = customer_data && customer_data?.content?.find(obj => Number(obj.id) === Number(searchForm?.customerName?.value));
        //console.log("data", data);
        if (data) {
            setCustomerInfo(data);
        } else {
            setCustomerInfo({ name: quoteSelectedTenantdata?.contactName, address: "" })
        }
        quoteData?.forEach(item => {
            setIsManagerApproval(overAllMarginHandler(item, subTotalHandler(item)) < login_user_data?.discountPurview)
        });

        setSelectTemplate(templateList[0])

    }, [customer_data, quoteData]);



    const confirmHandler = (conform) => {
        console.log(quoteData, "quoteData confirmHandler");
        let historyData = quoteData.map(data => {
            return {
                statusTime: new Date().toTimeString().split(' ')[0],
                statusDate: new Date().toISOString().split('T')[0],
                reasonMasterId: reason_master?.find(reason => String(reason?.reasonCode) === "INVALID")?.id,
                statusMasterId: conform ? status_master?.find(status => String(status?.statusCode) === VERIFIED)?.id : isManagerApproval ? status_master?.find(status => String(status?.statusCode) === MGR_APPRV_PENDING)?.id : status_master?.find(status => String(status?.statusCode) === draft)?.id,
            };
        });

        let addedCharges = mainChargeObj.map(data => {
            return {
                tenantFclQuotationsCarrierCharges: data.tariffDetails.flatMap(charge =>
                    charge.fclTariffBreakDowns.map(breakDown => {
                        return {
                            currency: currency_data?.find(currency => String(currency.currencyCode) === String(breakDown?.currencyCode)),
                            chargeHeader: charge?.header,
                            oceanContainer: container_data?.find(container => String(container?.value) === String(breakDown?.containerDetail)),
                            unitOfMeasurement: UOM_data?.find(uom => String(uom?.value) === String(breakDown?.value)),
                            unitCost: breakDown?.unit,
                            totalSaleCost: breakDown?.total_sale_cost,
                            totalBuyCost: breakDown?.total_sale_cost,
                            chargeName: breakDown?.component?.surchargeCategory,
                            markupType: breakDown?.markup_type || "PERCENTAGE",
                            markupValue: breakDown?.markup_val,
                            chargeMarginAmount: breakDown?.margin_value
                        };
                    })
                )
            };
        });

        let sellerTenantObject = {
            sellerTenantId : quoteData[0]?.tenantId
        }

        let data = {
            tenantFclQuotationSellerTenants: [sellerTenantObject],
            tenantCustomerId: searchForm?.customerName?.value || parseInt(quoteData[0]?.customerId),
            contactName: customerInfo?.name || quoteData[0]?.contactName,
            contactNo: customerInfo?.contactNo || quoteData[0]?.contactNumber,
            ...(instantInquiryId !== '' && { inquiryDetailId: instantInquiryId }),
            contactEmail: customerInfo?.contactEmail || quoteData[0]?.contactEmail,
            statusMasterId: conform ? status_master?.find(status => String(status?.statusCode) === VERIFIED)?.id : isManagerApproval ? status_master?.find(status => String(status?.statusCode) === MGR_APPRV_PENDING)?.id : status_master?.find(status => String(status?.statusCode) === draft)?.id,
            tenantFclQuotationStatusHistories: historyData,
            tenantFclQuotationCarrierDetails: quoteData.map((data, index) => {
                const vendor = vendor_data?.content?.find(vendor => Number(vendor.id) === Number(data?.carrierId));
                const originalCharges = data.tariffDetails.flatMap(charge =>
                    charge.fclTariffBreakDowns.map(breakDown => {
                        return {
                            currency: currency_data?.find(currency => String(currency.currencyCode) === String(breakDown?.currencyCode)),
                            chargeHeader: charge?.header,
                            ...(charge?.chargeId !== 0 && { tenantOceanFCLFreightRPId: charge?.chargeId }),
                            oceanContainer: container_data?.find(container => String(container?.value) === String(breakDown?.containerDetail)),
                            unitOfMeasurement: UOM_data?.find(uom => String(uom?.value) === String(breakDown?.uomCode)),
                            unitCost: breakDown?.unit,
                            totalBuyCost: breakDown?.unitPerPrice,
                            chargeName: breakDown?.component,
                            markupType: breakDown?.markup_type || "PERCENTAGE",
                            markupValue: breakDown?.markup_val || 0,
                            chargeMarginAmount: breakDown?.margin_value,
                            totalSaleCost: breakDown?.total_sale_cost || breakDown?.amount,
                        };
                    })
                );

                const mergedCharges = [
                    ...originalCharges,
                    ...(addedCharges[index]?.tenantFclQuotationsCarrierCharges || [])
                ];
                //{ id: quoteData[0]?.destinationId.toString(), label: quoteData[0]?.destinationName, value: quoteData[0]?.destinationName, version: "0" }
                // { id: quoteData[0]?.originId.toString(), label: quoteData[0]?.originName, value: quoteData[0]?.originName, version: "0" }
                console.log(vendor_carrier_data?.content, "vendor_carrier_data?.content");
                return {
                    carrierMaster: vendor_carrier_data?.content?.find(item => item.id === (data?.carrierId || quoteData[0]?.carrierInfo?.value)) ||  quoteData[0]?.carrierInfo?.tenantVendor || quoteData[0]?.carrierInfo,
                    ...(quoteData[0].carrierId && {carrierMaster: vendor_carrier_data?.content?.find(item => item.id === (quoteData[0].carrierId)) }),
                    ...(vendor?.id && { tenantVendorId: vendor?.id }),
                    remarks: data?.remarks,
                    destinationPortId: searchForm?.location_to?.value || quoteData[0]?.destinationId,
                    originPortId: searchForm?.location_from?.value || quoteData[0]?.originId,

                    ...(vendor?.city?.id !== 0 || vendor?.city !== undefined && { originCityId: vendor?.city?.id }),
                    ...(vendor?.city?.id !== 0 || vendor?.city !== undefined && { destinationCityId: vendor?.city?.id }),
                    ...(quoteData[0]?.originCityId !== 0 && { originCityId: quoteData[0]?.originCityId }),
                    ...(quoteData[0]?.destinationCityId !== 0 && { destinationCityId: quoteData[0]?.destinationCityId }),


                    tenantFclQuotationsCarrierCharges: (quoteData?.[0]?.quoteFrom === 'smartQuotation') ? originalCharges : mergedCharges,
                    grossMargin: overAllMarginHandler(data, subTotalHandler(data)),
                    //originLocationType: quoteData[0]?.originLocationType,

                    originLocationType : locationTypeMap[quoteData?.[0]?.originLocationType] || quoteData?.[0]?.originLocationType,

                    // ...(quoteData[0]?.originLocationType === "PORT" ? {
                    //     originLocationType: "OCEAN_PORT",
                    // } : quoteData[0]?.originLocationType === "CITY" ? {
                    //     originLocationType: "CITY",
                    // } : quoteData[0]?.originLocationType === "ICD" ? {
                    //     originLocationType: "ICD",
                    // } : ''),
                    //
                    // ...(quoteData[0]?.destinationLocationType === "PORT" ? {
                    //     destinationLocationType: "OCEAN_PORT",
                    // } : quoteData[0]?.destinationLocationType === "CITY" ? {
                    //     destinationLocationType: "CITY",
                    // } : quoteData[0]?.destinationLocationType === "ICD" ? {
                    //     destinationLocationType: "ICD",
                    // } : ''),

                    destinationLocationType : locationTypeMap[quoteData?.[0]?.destinationLocationType] || quoteData?.[0]?.destinationLocationType,

                    transitTime: data?.oceanTransitTime,
                    detentionFreeOrg: parseInt(data?.detentionFreeOrg),
                    detentionFreeDest: parseInt(data?.detentionFreeDest),
                    viaPorts: data?.viaPorts?.map(item => item?.id).filter(id => id !== undefined).join(','),
                    quotationValidFrom: data?.validFrom,
                    quotationValidTo: data?.validTo,
                    quotationValue: subTotalHandler(data),
                };
            })
        };
        console.log(data, "Payload");
        dispatch(postTenantQuotationSummeryDetails(data));
        setPreviewModal(false);
    }

    const onClickVerifyAndDownLoad = () => {
        // const componentToCapture = document.getElementById('component-to-capture');

        // const images = Array.from(componentToCapture.getElementsByTagName('img'));
        // const imagePromises = images.map(img => {
        //     return new Promise((resolve) => {
        //         if (img.complete) resolve();
        //         else img.onload = resolve;
        //     });
        // });

        // Promise.all(imagePromises).then(() => {
        //     html2canvas(componentToCapture, { useCORS: true }).then((canvas) => {
        //         const pdf = new jsPDF('p', 'mm', 'a4');
        //         pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, 210, 297);
        //         pdf.save(instantInquiryId + '.pdf');
        //     });
        // });
        //generatePDF(quoteData[0],tenant_info,quoteSelectedTenantdata, subTotalHandler(quoteData[0]),searchForm?.quote_currency?.currencyCode);
        setTimeout(() => {
            confirmHandler(true);
        }, 2000);
    };

    const handleDownloadPDF = () => {
        if (!isDraftDisplay) {
          //  window.print();
            //generatePDF(quoteData[0],tenant_info,quoteSelectedTenantdata, subTotalHandler(quoteData[0]),searchForm?.quote_currency?.currencyCode);
            // const componentToCapture = document.getElementById('component-to-capture');

            // const images = Array.from(componentToCapture.getElementsByTagName('img'));
            // const imagePromises = images.map(img => {
            //     return new Promise((resolve) => {
            //         if (img.complete) resolve();
            //         else img.onload = resolve;
            //     });
            // });

            // Promise.all(imagePromises).then(() => {
            //     html2canvas(componentToCapture, { useCORS: true }).then((canvas) => {
            //         const pdf = new jsPDF('p', 'mm', 'a4');
            //         pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, 210, 297);
            //         pdf.save(quoteSelectedTenantdata?.inquiryDetailId + '.pdf');
            //     });
            // });
        } else {
            confirmHandler(false);
        }
    };

    const handleDraftDownloadPdf = () => {
        if (isDraftDisplay) {
            setTimeout(() => {
                confirmHandler(false);
            }, [2000])
        }
    };

    const subTotalHandler = (quoteObject) => {
        let mainChargeCurr = mainChargeObj?.find(obj => obj.id === quoteObject.quote_id) || [];

        const totalSum = quoteObject?.tariffDetails?.reduce((accOuter, currentOuter) => {
            let innerSum = 0;
            if (currentOuter?.selected) {
                innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
                    return accInner + convertCurrency(currentInner, Number(currentInner.amount), currency_ExchangeRate, searchForm);
                }, 0);
            }
            return accOuter + innerSum;
        }, 0);
        const totalMarginSum = quoteObject?.tariffDetails?.reduce((accOuter, currentOuter) => {
            let innerSum = 0;
            if (currentOuter?.selected) {
                innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
                    return accInner + convertCurrency(currentInner, currentInner?.margin_value, currency_ExchangeRate, searchForm);
                }, 0);
            }
            return accOuter + innerSum;
        }, 0);

        const newSubTotal = mainChargeCurr?.tariffDetails !== undefined ? mainChargeCurr?.tariffDetails?.reduce((accOuter, currentOuter) => {
            let innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
                let totalAmt = Number(currentInner.unitPerPrice || 0) * Number(currentInner.unit || 1);
                return accInner + convertCurrency(currentInner, Number(totalAmt), currency_ExchangeRate, searchForm);;
            }, 0);
            return accOuter + innerSum;
        }, 0) : 0;

        const totalNewMarginSum = mainChargeCurr?.tariffDetails !== undefined ? mainChargeCurr?.tariffDetails?.reduce((accOuter, currentOuter) => {
            let innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
                return accInner + convertCurrency(currentInner, currentInner?.margin_value, currency_ExchangeRate, searchForm);
            }, 0);
            return accOuter + innerSum;
        }, 0) : 0;
        let mainTotal = totalSum + newSubTotal + totalMarginSum + totalNewMarginSum;
        return Math.ceil(mainTotal);
    }

    const overAllMarginHandler = (quoteObject, subtotalvalue) => {
        let mainChargeCurr = mainChargeObj?.find(obj => obj.id === quoteObject.quote_id) || [];

        const totalMarginSum = quoteObject?.tariffDetails?.reduce((accOuter, currentOuter) => {
            let innerSum = 0;
            if (currentOuter?.selected) {
                innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
                    return accInner + convertCurrency(currentInner, currentInner?.margin_value, currency_ExchangeRate, searchForm);
                }, 0);
            }
            return accOuter + innerSum;
        }, 0);

        const totalNewMarginSum = mainChargeCurr?.tariffDetails !== undefined ? mainChargeCurr?.tariffDetails?.reduce((accOuter, currentOuter) => {
            let innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
                return accInner + convertCurrency(currentInner, currentInner?.margin_value, currency_ExchangeRate, searchForm);
            }, 0);
            return accOuter + innerSum;
        }, 0) : 0;


        let totalMargin = totalMarginSum + totalNewMarginSum;
        let buyvalue = subtotalvalue - totalMargin

        return (totalMargin * 100 / buyvalue).toFixed(2)
    }

    const handleTemplateGroup = (templateItem) => {
        setSelectTemplate(templateItem);
        setPreviewFormat(templateItem.value);
    };

    return (
        <>
            <Modal size="md" isOpen={previewModal} toggle={() => { previewModalHand(); }} className='preview_modal_wrap'>
                <div className="modal-header modal-left-button" style={{width: '20%'}}>
                    <Select
                        value={selectTemplate}
                        name='template_name'
                        onChange={(opt) => {
                            handleTemplateGroup(opt);
                        }}
                        options={templateList}
                        defaultValue={templateList[0]}
                        placeholder={'Template List'}
                        classNamePrefix="select2-selection form-select"
                    />
                    <div className="format_image_wrap" style={{marginTop: 15}}>
                        {
                            previewFormat === '1' ? (
                                <div className={`img ${previewFormat === '1' ? 'active' : ''}`} onClick={() => {
                                    setPreviewFormat('1')
                                }}><img src={preview1} alt="Preview"/></div>
                            ) : (
                                <div className={`img ${previewFormat === '2' ? 'active' : ''}`} onClick={() => {
                                    setPreviewFormat('2')
                                }}><img src={preview2} alt="Preview"/></div>
                            )
                        }

                    </div>
                </div>
                <div className="modal-header">
                    <button type="button" onClick={() => {
                        setPreviewModal(false);
                    }}><i className='bx bx-plus me-2'></i> Close
                    </button>
                    {isDraftDisplay &&
                        <>
                            {isEditDisplay && (
                                <button type="button" onClick={() => {
                                    setPreviewModal(false);
                                    QuoteModalHandler("edit")
                                }}><img src={edit_icon} alt="Edit" className='me-2'/> Edit
                                </button>
                            )}
                            <button type="button" onClick={() => handleDraftDownloadPdf()}>
                                <i className='bx bx-check-circle me-2'></i>
                                {
                                    previewFormat === '2' ? (
                                        <PDFDownloadLink document={<GeneratePDFRenderOne
                                            quoteData={quoteData[0]}
                                            tenant_info={tenant_info}
                                            customerInfo={customerInfo || searchForm?.customerName}
                                            quoteSelectedTenantdata={quoteSelectedTenantdata}
                                            totalAmt={subTotalHandler(quoteData[0])}
                                            currencyCode={searchForm?.quote_currency?.currencyCode}
                                            mainChargeObj={mainChargeObj}/>
                                        } fileName={`${quoteSelectedTenantdata?.inquiryDetailId || quoteData[0].chargeId}.pdf`}>
                                            {isManagerApproval ? 'Request For Approval' : "Draft"}
                                        </PDFDownloadLink>
                                    ) : (
                                        <PDFDownloadLink document={<NewGeneratePDFRender
                                            quoteData={quoteData[0]}
                                            tenant_info={tenant_info}
                                            customerInfo={customerInfo || searchForm?.customerName}
                                            quoteSelectedTenantdata={quoteSelectedTenantdata}
                                            totalAmt={subTotalHandler(quoteData[0])}
                                            currencyCode={searchForm?.quote_currency?.currencyCode}
                                            mainChargeObj={mainChargeObj}/>
                                        } fileName={`${quoteSelectedTenantdata?.inquiryDetailId || quoteData[0].chargeId}.pdf`}>
                                            {isManagerApproval ? 'Request For Approval' : "Draft"}
                                        </PDFDownloadLink>
                                    )
                                }
                            </button>
                            <button type="button" onClick={() => {
                                onClickVerifyAndDownLoad();
                            }}><i className='bx bx-download me-2'></i>
                                {
                                    previewFormat === '2' ? (
                                        <PDFDownloadLink document={<GeneratePDFRenderOne
                                            quoteData={quoteData[0]}
                                            tenant_info={tenant_info}
                                            customerInfo={customerInfo || searchForm?.customerName}
                                            quoteSelectedTenantdata={quoteSelectedTenantdata}
                                            totalAmt={subTotalHandler(quoteData[0])}
                                            currencyCode={searchForm?.quote_currency?.currencyCode}
                                            mainChargeObj={mainChargeObj}/>
                                        } fileName={`${quoteSelectedTenantdata?.inquiryDetailId || quoteData[0].chargeId}.pdf`}>
                                            {({loading}) =>
                                                loading ? 'Loading document...' : 'Confirm'
                                            }
                                        </PDFDownloadLink>
                                    ) : (
                                        <PDFDownloadLink document={<NewGeneratePDFRender
                                            quoteData={quoteData[0]}
                                            tenant_info={tenant_info}
                                            customerInfo={customerInfo || searchForm?.customerName}
                                            quoteSelectedTenantdata={quoteSelectedTenantdata}
                                            totalAmt={subTotalHandler(quoteData[0])}
                                            currencyCode={searchForm?.quote_currency?.currencyCode}
                                            mainChargeObj={mainChargeObj}/>
                                        } fileName={`${quoteSelectedTenantdata?.inquiryDetailId || quoteData[0].chargeId}.pdf`}>
                                            {({loading}) =>
                                                loading ? 'Loading document...' : 'Confirm'
                                            }
                                        </PDFDownloadLink>
                                    )
                                }
                            </button>
                        </>
                    }
                    {!isDraftDisplay && quotationData?.statusCode != draft && quoteData[0] != undefined &&
                        <>
                            <div style={{
                                background: '#fff',
                                padding: '4px 16px 4px 12px',
                                borderRadius: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: '12px',
                                fontWeight: '500',
                                fontSize: '14px',
                                lineHeight: 'normal',
                                color: '#2D1C5B',
                                border: '1px solid #D1D5DB',
                                boxShadow: '0px 1px 0px 0px rgba(0, 0, 0, 0.05)'
                            }}>
                                <i className='bx bx-check-circle me-2'></i>
                                {
                                    previewFormat === '2' ? (
                                        <PDFDownloadLink document={<GeneratePDFRenderOne
                                            quoteData={quoteData[0]}
                                            tenant_info={tenant_info}
                                            customerInfo={customerInfo || searchForm?.customerName}
                                            quoteSelectedTenantdata={quoteSelectedTenantdata}
                                            totalAmt={subTotalHandler(quoteData[0])}
                                            currencyCode={searchForm?.quote_currency?.currencyCode}
                                            mainChargeObj={mainChargeObj}/>
                                        } fileName={`${quoteSelectedTenantdata?.inquiryDetailId}.pdf`}>
                                            {({loading}) =>
                                                loading ? 'Loading document...' : 'Download'
                                            }
                                        </PDFDownloadLink>
                                    ) : (
                                        <PDFDownloadLink document={<NewGeneratePDFRender
                                            quoteData={quoteData[0]}
                                            tenant_info={tenant_info}
                                            customerInfo={customerInfo || searchForm?.customerName}
                                            quoteSelectedTenantdata={quoteSelectedTenantdata}
                                            totalAmt={subTotalHandler(quoteData[0])}
                                            currencyCode={searchForm?.quote_currency?.currencyCode}
                                            mainChargeObj={mainChargeObj}/>
                                        } fileName={`${quoteSelectedTenantdata?.inquiryDetailId}.pdf`}>
                                        {({loading}) =>
                                                loading ? 'Loading document...' : 'Download'
                                            }
                                        </PDFDownloadLink>
                                    )
                                }

                            </div>
                        </>
                    }

                </div>
                <div id="component-to-capture" className="modal-body">
                    {previewFormat === '2' ? <PreviewFormat2 customerInfo={customerInfo} isSingleData={isSingleData} /> : <PreviewFormat1 customerInfo={customerInfo} isSingleData={isSingleData} />}
                </div>
            </Modal>
        </>
    )
}
